import apiCore from "services/apiCore";

export default {
    getAnalyticsDataRetention: function () {
        return apiCore.v2.get("/analytics/dataretention/settings");
    },
};
